import React from 'react';
import styled, { keyframes } from 'styled-components';
import qrCodeUrl from '../assets/qr-code.png';
const logoUrl = 'https://i.imgur.com/wY6a3yF.png'; // Placeholder brain logo

const Hero = () => {
  return (
    <HeroSection id="home">
      <Container>
        <Logo src={logoUrl} alt="MindBridge Logo" />
        <Tagline>Evidence-Based Mental Health for Youth Ages 15-24</Tagline>
        <Subtitle>Scan to Test MindBridge Live</Subtitle>
        <QRCodeWrapper>
          <QRCode src={qrCodeUrl} alt="Scan to test MindBridge Live" />
          <QRCodeText>Scan to test the MindBridge app live on your device</QRCodeText>
        </QRCodeWrapper>
      </Container>
    </HeroSection>
  );
};

export default Hero;

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const HeroSection = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: linear-gradient(-45deg, #4A90E2, #2C5AA0, #67B26F, #2C5AA0);
  background-size: 400% 400%;
  animation: ${gradientAnimation} 15s ease infinite;
  color: var(--text-light);
  padding-top: 80px; // Offset for fixed header
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  animation: ${fadeIn} 1s ease-out;
`;

const Logo = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: 2rem;
  animation: ${fadeIn} 1s ease-out 0.2s backwards;
`;

const Tagline = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  animation: ${fadeIn} 1s ease-out 0.4s backwards;
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  margin: 0 0 2rem 0;
  opacity: 0.9;
  animation: ${fadeIn} 1s ease-out 0.6s backwards;
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const QRCodeWrapper = styled.div`
  display: inline-block;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 15px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  animation: ${fadeIn} 1s ease-out 0.8s backwards;
  box-sizing: border-box;
`;

const QRCode = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
`;

const QRCodeText = styled.p`
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-dark);
  margin: 1rem 0 0 0;
`;
